module.exports = __webpack_public_path__ + "VAGRoundedStd-Thin.f7732b9eda8e07ba18cf.woff";


//////////////////
// WEBPACK FOOTER
// /var/www/minhaloga-cliente/src/app/@theme/fontes/fonte-vag-rounded/VAGRoundedStd-Thin.woff
// module id = ../../../../../src/app/@theme/fontes/fonte-vag-rounded/VAGRoundedStd-Thin.woff
// module chunks = styles